const BulkPolicySelectColumn = [
  {
    title: 'Policy Name',
    dataIndex: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name),
    width: 250
  },
  {
    title: 'Description',
    dataIndex: 'description',
    sorter: (a, b) => a.description.localeCompare(b.description),
    width: 300
  },
  {
    title: 'URLs',
    dataIndex: 'urlCount',
    sorter: (a, b) => a.urlCount - b.urlCount,
    width: 100
  },
  {
    title: 'Rules',
    dataIndex: 'rulesCount',
    sorter: (a, b) => a.rulesCount - b.rulesCount,
    width: 100
  }
];

export { BulkPolicySelectColumn };

